import React, { useEffect, useState } from 'react'
import { order_history } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import FcModuleStyle from '../styles/fc.module.css';
import Button from '../../common/Button';
import uparrow_grey from '../assets/uparrow_grey.png';
import downarrow_grey from '../assets/downarrow_grey.png';

const PastDecision = ({ simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, isUtilizedActive, getMonth }) => {
    const [investmentOptions, setInvestmentOptions] = useState([]);
    const [isNoData, setIsNoData] = useState(false);
    // const forecast_list = ["Regular", "Midgrade", "Premium"];
    const [forecastList,setForecastList] = useState([]);
    const changeTabs = (e) => {
        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) { 
        const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
        tabs.forEach((tab) => {
            tab.setAttribute("tabindex", "-1");
        });

        const target = e.currentTarget;
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        if (window.$(e.target).closest('.ui.stackable.two.column')[0] != undefined) {
            grandparent = window.$(e.target).closest('.ui.stackable.two.column')[0];
        }

        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.style.color = "rgba(0,0,0,.6)";
                t.classList.remove(`${FcModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.style.color = "black";
        target.setAttribute("tabindex", "0");
        target.classList.add(`${FcModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent
                .querySelectorAll(`#${FcModuleStyle['panelList']}>div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        e.stopPropagation();
    }
    const handleTabs = () => {
        const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementById(`panel_2`).querySelector(`[role="tablist"]`);

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                changeTabs(e);
                const tabs = document.querySelectorAll('#panel_2 [role="tab"]');
                let activeTab = window.$(e.target).closest('.item.tab-item')[0];
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                }, 0)
            });
            tab.addEventListener("keydown", (e) => {
                if (e.key == "Enter") {
                    changeTabs(e);
                }
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        if (tabList != null) {
            tabList.addEventListener("keydown", (e) => {
                // Move right
                const tabs = document.getElementById(`panel_2`).querySelectorAll(`[role="tab"]`);
                if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                    let activeTab = document.getElementById(`panel_2`).querySelector(`[role="tab"].active`)
                    tabs.forEach((tab) => {
                        tab.setAttribute("tabindex", "-1");
                    });
                    setTimeout(() => {
                        activeTab.setAttribute("tabindex", "0");
                        tabFocus = Array.from(tabs).indexOf(activeTab);
                    }, 100)
                }
                if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                    tabs[tabFocus].setAttribute("tabindex", -1);
                    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                        tabFocus++;
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                        // Move left
                    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                        tabFocus--;
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }
                    else if (e.key === "Home") {
                        tabFocus = 0;
                    }
                    else if (e.key === "End") {
                        tabFocus = tabs.length - 1;
                    }
                    e.preventDefault();
                    tabs[tabFocus].setAttribute("tabindex", 0);
                    tabs[tabFocus].focus();
                }
            });
        }

        // tabs[0].click();
    }
    useEffect(() => {
        document.querySelector(`.utilized-investments`).querySelectorAll(`.item.tab-item`).forEach((element, index) => {
            if (index == 0) {
                element.setAttribute("tabindex", "0");
            }
        });
        //setInvestmentOptions(simObj?.laststate?.investmentOptions);
    }, [simObj?.laststate?.investmentOptions?.QMInvestmentOptions, investmentOptions]);
    // useEffect(()=>{
    //     if(Object.keys(investmentOptions).length > 0){
    //         setIsNoData(false);
    //     }
    //     else{
    //         setIsNoData(true);
    //     }
    // },[investmentOptions])
    useEffect(() => {
        handleTabs();
        if (document.querySelector(".utilized-investments .tab-item")) {
            document.querySelector(".utilized-investments .tab-item:first-child").click();
        }
    }, [isUtilizedActive])
    useEffect(() => {
        handleTabs();
        if (document.querySelector("#panel_2 .tab-item")) {
            document.querySelector("#panel_2 .tab-item").click();
        }
    }, [investmentOptions])
    useEffect(()=>{
        if(simObj?.optionsAvailable){
            let optionsAvailable = simObj?.optionsAvailable
            let forecast_list = Object.keys(optionsAvailable).filter(key => optionsAvailable[key] === 1);
            setForecastList(forecast_list)
        }
    },[simObj?.optionsAvailable])

    return (
        <div className={`ui stackable two column grid ${FcModuleStyle['ui']} ${FcModuleStyle['two']} ${FcModuleStyle['stackable']} ${FcModuleStyle['grid']} ${FcModuleStyle['column']} utilized-investments ${!(Object.keys(investmentOptions).length > 0 && isNoData) ? `${FcModuleStyle['loaderParent']}` : ""}`}>
            {(simObj?.graphdata?.length > 0) && (<>
                <div className={`six wide column ${FcModuleStyle['six']} ${FcModuleStyle['wide']} ${FcModuleStyle['column']}`} tabIndex={-1}>
                    <div className={`ui secondary segment ${FcModuleStyle['ui']} ${FcModuleStyle['secondary']} ${FcModuleStyle['segment']}`}>
                        <ul className={`ui divided list ${FcModuleStyle['ui']} ${FcModuleStyle['list']}`} role="tablist" aria-label="Reviews tabs">
                            {
                                //${gdata?.currentRampValue == 1 ? 'active' : ''}
                                simObj?.graphdata?.sort((a, b) => (b.cr - a.cr))?.map((gdata, index) => (
                                    <li key={index} className={`item tab-item  ${FcModuleStyle['item']} ${FcModuleStyle['tab-item']} ${index == 0 ? 'active' : ''}`} data-tab={`_tab__${gdata.cr}`} aria-controls={`_tab__${gdata.cr}`} aria-selected={index == 0 ? true : false} role='tab' tabIndex={gdata.cr == 1 ? 0 : -1}>
                                        <div className={`${FcModuleStyle['content']}`}>
                                            <p>{getMonth(gdata.sm)} {new Date(gdata.cd).getFullYear()}</p>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
                <div className={`ten wide column ${FcModuleStyle['ten']} ${FcModuleStyle['wide']} ${FcModuleStyle['column']}`}>
                    {
                        simObj?.graphdata?.sort((a, b) => (b.cr - a.cr))?.map((gdata, index) => (
                            <div key={index} className={`ui tab ${FcModuleStyle['review-container']} ${index == 0 ? 'active' : ''}`} data-tab={`_tab__${gdata.cr}`} role='tabpanel' tabIndex={0} id={`_tab__${gdata.cr}`}>
                                <div className={`${FcModuleStyle['decisions-table']}`}>
                                    <p>Forecast for {getMonth(gdata.sm)} {new Date(gdata.cd).getFullYear()}</p>
                                    <div className={`${FcModuleStyle['decision-table-parent']}`}>
                                        <table className="ui celled table unstackable">
                                            <tbody>
                                                {
                                                    forecastList?.map((item, index) =>
                                                    (<tr key={index}>
                                                        <td>
                                                            {item}
                                                        </td>
                                                        <td>
                                                            <div className={`${FcModuleStyle['inputBox']}`}>
                                                                <button className={`${FcModuleStyle['arrow-btn']}`} tabIndex={-1} disabled="disabled"><img src={downarrow_grey} /></button>
                                                                <input type="text" value={gdata?.fi[item.toUpperCase()].forecastDemand} disabled="disabled" />
                                                                <button className={`${FcModuleStyle['arrow-btn']}`} tabIndex={-1} disabled="disabled"><img src={uparrow_grey} /></button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <span>Gallons</span>
                                                            </div>
                                                        </td>
                                                    </tr>)
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ))

                    }
                </div> </>)}
            {/* {
              (simObj?.graphdata?.length > 0) &&  (
                    <div>
                        <div className="snippet" data-title="dot-pulse">
                            <div className={`${FcModuleStyle['stage']}`}>
                                <div className={`${FcModuleStyle['dot-pulse']}`}></div>
                            </div>
                        </div>
                    </div>
                )
            } */}
            {
                (simObj?.graphdata?.length == 0) && <div className={`empty ${FcModuleStyle['empty']}`}>
                    <div>
                        <div className={`ui info message ${FcModuleStyle['ui']} ${FcModuleStyle['info']} ${FcModuleStyle['message']}`}>
                            <div className="header">
                                Currently no past decisions.
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default PastDecision
